import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import redirectURL from "../redirectURL";



var decipher = salt => {
  const textToChars = text => text.split('').map(c => c.charCodeAt(0));
  const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
  return encoded => encoded.match(/.{1,2}/g)
      .map(hex => parseInt(hex, 16))
      .map(applySaltToChar)
      .map(charCode => String.fromCharCode(charCode))
      .join('');
}
var decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");
var localStorageRole = (localStorage.getItem("role"))
class TemperatureChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dates: [],
      plannedOrders: [],
      unplannedOrders: [],
      pendingOrders: [],
      totalOrders: [],
      series:[]
    };
  }
  componentDidMount() {
    var params = {}

    if (decode(localStorageRole) === "tpt"){
      if(localStorage.getItem('tpt_code') !== '' && localStorage.getItem('tpt_code') !== undefined){
        params.transporter_code = localStorage.getItem('tpt_code')
      }
    }
    if (decode(localStorageRole)=== "warehouse"){
      if(localStorage.getItem('warehouse_code') !== '' && localStorage.getItem('warehouse_code') !== undefined){
        params.destination = localStorage.getItem('warehouse_code')
      }
    }
    redirectURL.post("/dispatch/getordersfortrendchart",params)
     .then(response => {
        // console.log("response10", JSON.stringify(response.data));
        var records = response.data;
        var dates = []
        var plannedOrders = []
        var unplannedOrders = []
        var pendingOrders = []
        var totalOrders = []
        if(records.length > 0)
        {
          dates = records.map(item => item.date);
          plannedOrders = records.map(item => item.plannedOrders);
          unplannedOrders = records.map(item => item.unplannedOrders);
          pendingOrders = records.map(item => item.pendingOrders);
          totalOrders = records.map(item => item.totalOrders);
        }
        this.setState({
          dates: dates,
          plannedOrders: plannedOrders,
          unplannedOrders: unplannedOrders,
          pendingOrders: pendingOrders,
          totalOrders: totalOrders,
          series:[
            {
              name: 'Approved Orders',
              data: plannedOrders,
              // type: 'column'
            },
            {
              name: 'Rejected Orders',
              data: unplannedOrders,
              // type: 'column'
            },
            {
              name: 'Pending Orders',
              data: pendingOrders,
              // type: 'column'
            },
            {
              name: 'Total Orders',
              data: totalOrders,
              // type: 'spline'
            }
          ]
        },()=>{
          // console.log("dates",this.state.dates);
          // console.log("plannedOrders",this.state.plannedOrders);
          // console.log("unplannedOrders",this.state.unplannedOrders);
          // console.log("pendingOrders",this.state.pendingOrders);
          // console.log("totalOrders",this.state.totalOrders);

          this.renderChart()
        })

     })
  
    
  }


  
  renderChart = () => {
    const daysInCurrentMonth = this.getDaysInCurrentMonth();
    var totals = this.state.series.map(s => s.data.reduce((sum, y) => sum + y, 0));
    var series = this.state.series;
    Highcharts.chart('temperatureContainer', {
      chart: {
        type: 'spline'
      },
      title: {
        text: '',
        align:'left'
      },
    //   subtitle: {
    //     text: 'Source: ' +
    //           '<a href="https://en.wikipedia.org/wiki/List_of_cities_by_average_temperature" ' +
    //           'target="_blank">Wikipedia.com</a>'
    //   },
    xAxis: {
      categories: this.state.dates,
      title: {
        text: ''
      }
    },
    yAxis: {
      title: {
        text: 'No Of Orders'
      }
    },
    plotOptions: {
      column: {
          stacking: 'normal',
          dataLabels: {
              enabled: true
          }
      }
  },
    colors:["#77B0AA","#FFC470","#DD5746","#4793AF"],
    series: series,
    legend: {
      labelFormatter: function () {
          // Find the total for the current series
          if(series.length > 0)
          {
            var index = series.findIndex(s => s.name === this.name);
            var seriesTotal = totals[index];
            return this.name + ' - ' + seriesTotal + '';
          }
          
      }
    },
    credits:false
    });
  }

  getDaysInCurrentMonth = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    const daysArray = [];
    for (let day = 1; day <= daysInMonth; day++) {
      daysArray.push(day.toString());
    }

    return daysArray;
  }

  generateDummyData = (numDays, min, max) => {
    const data = [];
    for (let i = 0; i < numDays; i++) {
      data.push(parseFloat((Math.random() * (max - min) + min).toFixed(1)));
    }
    return data;
  }

  render() {
    return (
      // <div className="row">
      //   <div className="col-sm-12">
      //     <div id="temperatureContainer" style={{ height: '300px', width: '100%' }}></div>
      //   </div>
      // </div>

      <div className="card" >
      <div className="card-body">
        <div className="d-flex flex-row justify-content-between align-items-center w-100 pb-2 pr-5">
          <div className="ml-4 mt-2 font-weight-bold d-flex flex-row justify-content-center align-items-baseline" >
            <span className="ml-2 f18">Day wise Order Status</span>
          </div>
        </div>

        <div className="d-flex flex-row justify-content-between align-items-center leFadeInLeft w-100 pr-1">
          
          <div className='col-sm-12'>
            <div id="temperatureContainer" style={{ height: '300px', width: '100%' }}></div>
          </div>
          
        </div>
      </div>
      </div>
    );
  }
}

export default TemperatureChart;
